export type CerbosView =
  | 'view:system_dongle_management'
  | 'view:system_account_management'
  | 'view:system_batch_job_list'
  | 'view:system_session_links'
  | 'view:system_user_administration'
  | 'view:system_user_administration_edit'
  | 'view:system_project_transfer'
  | 'view:project_geodata_list'
  | 'view:project_settings'
  | 'view:project_timelines'
  | 'view:project_geodata_gcp_flags'
  | 'view:project_administration_users'
  | 'view:project_connect'
  | 'view:company_list'
  | 'view:company_overview'
  | 'view:company_licenses'
  | 'view:company_admins'
  | 'view:company_invite_admin'
  | 'view:company_administration_project_list'
  | 'view:dashboard'
  | 'view:project_users'
  | 'view:project_overview'
  | 'view:project_skyview'
  | 'view:project_file_manager'
  | 'view:project_3d_models_list'
  | 'view:project_3d_models_new'
  | 'view:project_3d_models_details'
  | 'view:project_email'
  | 'view:access_rights';

// A list of views that supports Cerbos policy checks.
export const cerbosControlledViews: Set<CerbosView> = new Set<CerbosView>([
  'view:system_session_links',
  'view:system_user_administration',
  'view:system_user_administration_edit',
  'view:system_project_transfer',
  'view:system_dongle_management',
  'view:system_account_management',
  'view:system_batch_job_list',
  'view:project_geodata_list',
  'view:project_settings',
  'view:company_list',
  'view:company_overview',
  'view:company_licenses',
  'view:company_admins',
  'view:company_invite_admin',
  'view:company_administration_project_list',
  'view:project_timelines',
  'view:project_geodata_gcp_flags',
  'view:project_administration_users',
  'view:project_connect',
  'view:dashboard',
  'view:project_users',
  'view:project_overview',
  'view:project_skyview',
  'view:project_file_manager',
  'view:project_3d_models_list',
  'view:project_3d_models_new',
  'view:project_3d_models_details',
  'view:project_email',
  'view:access_rights',
]);
